import { SunIcon, MoonIcon } from "@heroicons/react/24/outline";
import { useMemo } from "react";

import { Button } from "@/components/ui/Button";
import { useTheme } from "@/app/providers/ThemeProvider";
import { useAuth } from "@/features/auth/state/useAuth";

export const Topbar = () => {
    const { theme, setTheme } = useTheme();
    const { user } = useAuth();

    const userDisplayName = useMemo(() => {
        if (!user) return "RideToFive Admin";
        return user.fullName || `${user.firstName} ${user.lastName}`.trim() || user.email;
    }, [user]);

    const initials = useMemo(() => {
        if (!user) return "AD";
        const first = user.firstName?.[0] ?? "";
        const last = user.lastName?.[0] ?? "";
        return `${first}${last}`.toUpperCase() || user.email?.[0]?.toUpperCase() || "AD";
    }, [user]);

    const toggleTheme = () => setTheme(theme === "light" ? "dark" : "light");

    return (
        <header className="flex h-16 items-center justify-end border-b border-slate-200 bg-white/70 px-6 backdrop-blur-md dark:border-slate-800 dark:bg-slate-900/60">
            <div className="flex items-center gap-3">
                <Button variant="ghost" size="icon" onClick={toggleTheme} aria-label="Toggle theme">
                    {theme === "light" ? (
                        <MoonIcon className="h-5 w-5 text-slate-600 dark:text-slate-200" />
                    ) : (
                        <SunIcon className="h-5 w-5 text-amber-300" />
                    )}
                </Button>
                <div className="flex flex-col items-end gap-1 text-right">
                    <span className="text-sm font-medium text-slate-700 dark:text-slate-100">
                        {userDisplayName}
                    </span>
                </div>
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 text-sm font-semibold text-white">
                    {initials}
                </div>
            </div>
        </header>
    );
};
